export const CONFIG = {
  API_PREFIX: process.env.VUE_APP_API_PREFIX ? process.env.VUE_APP_API_PREFIX : '',
  API_VER: 'web-api/v1'
}

export const DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right'
}

export const OSS_PREFIX = {
  MEDIA_FILES: 'media-files/'
}

export const STRIPE = {
  PUBLIC_KEY: 'pk_test_r1SJQgvlbpRZImQzSWahXg5200dHW7Ghvq'
}

export const ROOT_STATUS = {
  STATUS_DEFAULT : {
    key: 'STATUS_DEFAULT',
    value: 'Unknown',
    color: 'primary',
    icon: '',
  },
}